/**
 * Created by Josef Jurca on 17/07/2017.
 */
import _ from 'lodash';

/**
 * Converts asset data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} History data.
 */
export function convertFromRead (data = {}) {

    let {objects} =  data,
        bookmarks = _.map(objects, (bookmark) => {
           return {
               id: bookmark.id || null,
               type: bookmark.type || '',
               finishedWatching: bookmark.finishedWatching || false,
               position: bookmark.position || 0,
               apiSpecifics: {
                   playerData: bookmark.playerData || {}
               }
           };
        });

    return bookmarks;
}

/**
 * Converts application data for bookmark request.
 *
 * @param {Array} ids - Assets ids.
 * @returns {Object} Request data.
 */
export function convertForGetBookmarks (ids) {

    return {
        filter: {
            'objectType': 'KalturaBookmarkFilter',
            'assetIdIn': ids.join(),
            'assetTypeEqual': 'media'
        }
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/bookmark.js